import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { PeremrillojiParametri, PeremriNumri, PeremriRasa, PeremriRenditja, PeremriTrajta } from '@core/enums/peremri/peremri.enum';
import { PeremriConstants } from '@core/globals/peremri/peremri-constants';
import { PeremriForCreationDTO } from '@core/interfaces/dto/peremri-for-creation-dto.interface';
import { PeremriBaza } from '@core/interfaces/models/peremri-baza.interface';
import { PeremriDeftorFormulaService } from './peremri-deftor-formula.service';

@Injectable({
  providedIn: 'root'
})
export class PeremriDeftorService {

  constructor(
    private fb: UntypedFormBuilder,
    private peremriDeftorFormulaService: PeremriDeftorFormulaService,
  ) { }

  insertForms(peremriBaza: PeremriBaza, form: UntypedFormGroup, manual: boolean) {
    const formArray = form.get('peremriBaza.peremriDeftor') as UntypedFormArray;
    this.generateDeftoreForms(formArray, manual);
    peremriBaza.peremri?.forEach((item) => {
      let index = formArray.controls.findIndex(
        (c) =>
          c.get('renditjaId')?.value == item.renditjaId &&
          c.get('trajtaId')?.value == item.trajtaId &&
          c.get('vetaId')?.value == item.vetaId &&
          c.get('rasaId')?.value == item.rasaId &&
          c.get('pershkrimi')?.value == ''
      );
      if (index != -1) {
        formArray.controls[index].get('pershkrimi')?.setValue(item.pershkrimi);
      } else {
        this.addNewLakimi(form, item.renditjaId, item.trajtaId, item.numriId, item.rasaId, item.pershkrimi);
      }
    });
  }

  generateForms(form: UntypedFormGroup, manual: boolean) {
    this.generateDeftoreForms(form.get('peremriBaza.peremriDeftor') as UntypedFormArray, manual);
  }

  generateFormula(peremriLlojiParametri: PeremrillojiParametri, form: UntypedFormGroup) {
    let formArray = form.get('peremriBaza.peremriDeftor') as UntypedFormArray;
    this.peremriDeftorFormulaService.generateFormula(peremriLlojiParametri, formArray);
  }

  generateDeftoreForms(formArray: UntypedFormArray, manual: boolean) {

    while (formArray.length > 0) {
      formArray.removeAt(0);
    }
    for (const pre of PeremriConstants.PeremriRenditja) {
      for (const pt of PeremriConstants.PeremriTrajta) {
        for (const pn of PeremriConstants.PeremriNumri) {
          for (const pr of PeremriConstants.PeremriRasat) {
            const peremriForm = this.fb.group({
              renditjaId: pre.id,
              trajtaId: pt.id,
              numriId: pn.id,
              rasaId: pr.id,
              pershkrimi: '',
            });

            formArray.push(peremriForm);
          }
        }
      }
    }

    for (const pn of PeremriConstants.PeremriNumri) {
      for (const pr of PeremriConstants.PeremriRasat) {
        const peremriForm = this.fb.group({
          renditjaId: null,
          trajtaId: null,
          numriId: pn.id,
          rasaId: pr.id,
          pershkrimi: '',
        });

        formArray.push(peremriForm);
      }
    }

    if (!manual) formArray.disable();
  }

  addNewLakimi(form: UntypedFormGroup, renditja: number | null, trajta: number | null, numri: PeremriNumri | null, rasa: PeremriRasa | null, pershkrimi?: string) {
    const formArray = <UntypedFormArray>form.get('peremriBaza.peremriDeftor');
    const peremriForm = this.fb.group({
      renditjaId: renditja,
      trajtaId: trajta,
      numriId: numri,
      rasaId: rasa,
      pershkrimi: pershkrimi
    });
    formArray.push(peremriForm);
  }

  getCreationDTO(form: UntypedFormGroup) {
    const creationDTO: PeremriForCreationDTO[] = [];

    let formArray: UntypedFormArray;

    formArray = form.get('peremriBaza.peremriDeftor') as UntypedFormArray;

    formArray.value.forEach((p: any) => {
      creationDTO.push({
        renditjaId: p.renditjaId,
        trajtaId: p.trajtaId,
        numriId: p.numriId,
        rasaId: p.rasaId,
        pershkrimi: p.pershkrimi
      })
    })
    return creationDTO;
  }
}
